<template lang="pug">
v-dialog(v-model="showrender" width="500" class="classmsg" persistent)
    v-card
      v-card-title
        | {{titulo}}
        v-spacer
        v-btn(icon @click="showrender=false")
          v-icon mdi-close
      v-container(fluid)
        p {{ mensaje }}
      v-divider
      v-card-actions
        v-spacer
        div(v-if="tipo==1")
          v-btn(text color="blue"  @click="showrender=false") OK
        div(v-else)
          v-btn(text color="blue"  @click="accion(true)") SI
          v-btn(text color="blue"  @click="accion(false)") NO
</template>
<script>
  export default {
      data() {
          return {
              showrender:false,
              mensaje : '',
              titulo : '',
              tipo:'',
              returnAccion : null
          }
      },
      methods : {
          show(){
              this.showrender=true
          },
          accion(evento){
              this.showrender=false
              var funcionPromesa=this.returnAccion
              funcionPromesa(evento)
  
          }
  
      }
  }
  </script>
  <style>
  .classmsg{
    z-index :  2147483647 !important;
  }
  </style>
  